// LivestreamRatingButton.js
'use strict';
import { connect } from 'react-redux';

import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { LIVESTREAM_RATING_HINT_DURATION_SECONDS } from '../RemoteConfigKeys.js';

import RatingButton from '../component/RatingButton.jsx';

import getLiveStreamData from '../selector/getLiveStreamData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import toggleModal from '../action/toggleModal.js';

import { PRESET_PREVIEW } from '../resource/liveStreamConstants.js';

const mapStateToProps = (state, { id: streamId }) => {
  const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  return {
    streamId,
    sessionId,
    hintDurationSeconds: getRemoteConfigData(
      state,
      LIVESTREAM_RATING_HINT_DURATION_SECONDS
    ),
    ratedAs: getLiveStreamData(
      state,
      [streamId, 'rating', sessionId],
      'ratedAs'
    ),
    hintOpenedTimestamp: getOperationData(
      state,
      ['hint', 'livestreamRatingHintOpenedTimestamp'],
      'timestamp'
    ),
    canRate: PRESET_PREVIEW === streamStatus || hasStreamToken,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setHintOpenedTimestamp: ({ timestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['hint', 'livestreamRatingHintOpenedTimestamp'],
          data: {
            timestamp,
          },
        },
      }),
    openRatingModal: ({ id }) =>
      dispatch(
        toggleModal({
          modalId: 'LivestreamRatingModal',
          payload: {
            streamId: id,
          },
          isOpen: true,
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RatingButton);
